import { m } from '@aimfora/i18n'
import { cn } from '@aimfora/ui'
import { ArrowDownIcon } from 'lucide-react'

function BlackBox({ className }: { className: string }) {
  return (
    <span
      role="img"
      aria-label={m.forside_redact_covered()}
      className={cn('inline-block h-4 translate-y-0.5 rounded-sm bg-ink', className)}
    />
  )
}

/** A static two-stage picture of what stays in the browser and what is uploaded. */
export function RedactionFlow() {
  return (
    <div className="rounded-md border border-line bg-surface">
      <div className="p-5">
        <p className="font-semibold text-[13px] text-ink-soft">{m.forside_redact_before_label()}</p>
        <div className="mt-2 rounded-sm border border-line-strong bg-paper px-3 py-2.5 text-sm">
          <p className="font-medium text-[12.5px] text-ink-soft">anna-hansen-terminsproeve.pdf</p>
          <p className="mt-1.5">
            <span className="text-ink-soft">{m.forside_redact_name_label()}</span>{' '}
            <span className="font-medium">{m.forside_redact_name_value()}</span>
          </p>
        </div>
        <p className="mt-2 text-ink-soft text-sm">{m.forside_redact_before_note()}</p>
      </div>

      <div className="flex items-center gap-3 border-line border-y bg-paper px-5 py-3">
        <ArrowDownIcon className="size-4 shrink-0 text-ink" aria-hidden="true" />
        <p className="font-medium text-sm">{m.forside_redact_step()}</p>
      </div>

      <div className="p-5">
        <p className="font-semibold text-[13px] text-ink-soft">{m.forside_redact_after_label()}</p>
        <div className="mt-2 rounded-sm border border-line-strong bg-paper px-3 py-2.5 text-sm">
          <p className="font-medium text-[12.5px] text-ink-soft">{m.forside_redact_alias()}</p>
          <p className="mt-1.5">
            <span className="text-ink-soft">{m.forside_redact_name_label()}</span>{' '}
            <BlackBox className="w-24" />
          </p>
        </div>
        <p className="mt-2 text-ink-soft text-sm">{m.forside_redact_after_note()}</p>
      </div>
    </div>
  )
}
